import { useQuery } from '@tanstack/react-query'

import { apiClient } from '../apiClient'

type GetOntologyErrorsRequest = {
  programId?: string
  startDate?: string
  endDate?: string
}

type GetOntologyErrorsResponse = {
  featureName: string
  accuracy: number
  accuracyTrend: number
  commonMistakes: string | null
}[]

export function useGetOntologyErrors({ programId, startDate, endDate }: GetOntologyErrorsRequest) {
  return useQuery({
    queryKey: ['get-ontology-errors', programId, startDate, endDate],
    queryFn: async () => {
      const { data } = await apiClient.get<GetOntologyErrorsResponse>(
        `/int/v3/operators/ontology-errors/mine`,
        { params: { programId, startDate, endDate } }
      )
      return data
    },
    enabled: Boolean(programId) && Boolean(startDate) && Boolean(endDate),
    refetchOnWindowFocus: false,
  })
}
